import { connect } from 'react-redux'
import get from 'lodash/get';

import {
  changeSelectedCar as onChangeSelectedCar
} from '../../actions/selectedCarsActions'

const mapStateToProps = (state) => ({
  selectedCars: get(state, ["selectedCars", "data"], [])
})

const mapDispatchToProps = {
  onChangeSelectedCar
}

const withSelectedCars = Component => connect(mapStateToProps, mapDispatchToProps)(Component)

export { withSelectedCars }
